import { RSAA } from 'redux-api-middleware';
import cookie from 'react-cookies';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import languages from '@/utils/languages';
import { REQUEST, SUCCESS, FAILURE } from '@/modules/Requests';
import { lang, SET_LOCALE, SET_LOCALE_MESSAGES } from '@/modules/Locale';

export const CLEAN_USER = 'user/CleanUser';
export const SET_INIT = 'user/SET_INIT';
export const SET_TOKEN = 'user/SET_TOKEN';
export const SET_TASKS = 'USER/SET_TASKS';
export const SET_TOKENS = 'user/SET_TOKENS';
export const SET_PAY_ACC = 'user/SET_PAY_ACC';
export const SET_PROFILE = 'user/SET_PROFILE';
export const SET_AVTIVITY = 'user/SET_AVTIVITY';
export const SET_KYC_TOKEN = 'user/SET_KYC_TOKEN';
export const SET_APPLICANT_ID = 'user/SET_APPLICANT_ID';
export const SET_TWOFA_CHECKED = 'user/SET_TWOFA_CHECKED';
export const SET_TWOFA_SECRET_TOKEN = 'user/SET_TWOFA_SECRET_TOKEN';

export const REQUEST_TOKENS = 'user/requestTokens';
export const REQUEST_LOAD_DATA = 'user/requestLoadData';
export const REQUEST_EDIT_DATA = 'user/requestEditData';
export const REQUEST_LOAD_TASKS = 'USER/REQUEST_LOAD_TASKS';
export const REQUEST_CONFIRM_CODE = 'user/requestConfirmCode';
export const REQUEST_CONFIRM_PHONE = 'user/requestConfirmPhone';
export const REQUEST_CHANGE_PASSWORD = 'user/requestChangePassword';
export const REQUEST_VERIFY_PASSWORD = 'user/requestVerifyPassword';
export const REQUEST_KYC_ACCESS_DATA = 'user/requestKycAccessData';
export const REQUEST_CREATE_APPLICANT = 'user/REQUEST_CREATE_APPLICANT';
export const REQUEST_TWOFA_CHECK = 'user/requestTwofaCheck';
export const REQUEST_TWOFA_ACTIVATE = 'user/requestTwofaActivate';
export const REQUEST_TWOFA_DEACTIVATE = 'user/requestTwofaDeactivate';
export const REQUEST_TWOFA_SECRET_TOKEN = 'user/requestTwofaSecretToken';
export const REQUEST_LOAD_REFERRALS = 'USER/REQUEST_LOAD_REFERRALS';
export const REQUEST_PAYMENT = 'USER/REQUEST_PAYMENT';
export const SET_USER = 'SET_USER';
export const STUDENT_FORM = 'STUDENT_FORM';
export const REQUEST_STUDENT_CREATE = 'REQUEST_STUDENT_CREATE';
export const REQUEST_STUDENT_EDIT = 'REQUEST_STUDENT_EDIT';
export const REQUEST_STUDENT_DELETE = 'REQUEST_STUDENT_DELETE';
export const REQUEST_STUDENTS = 'REQUEST_STUDENTS';
export const REQUEST_STUDENT = 'REQUEST_STUDENT';
export const SET_STUDENTS = 'SET_STUDENTS';
export const GROUP_FORM = 'GROUP_FORM';
export const REQUEST_GROUP_CREATE = 'REQUEST_GROUP_CREATE';
export const REQUEST_GROUP_EDIT = 'REQUEST_GROUP_EDIT';
export const REQUEST_GROUP_DELETE = 'REQUEST_GROUP_DELETE';
export const REQUEST_ROOMS = 'USER/REQUEST_ROOMS';
export const SET_ROOMS = 'USER/SET_ROOMS';
export const REQUEST_GROUPS = 'REQUEST_GROUPS';
export const REQUEST_OWN_GROUPS = 'REQUEST_GROUPS';
export const SET_GROUPS = 'SET_GROUPS';
export const SET_SCHEDULE = 'SET_SCHEDULE';
export const REQUEST_GET_SCHEDULE = 'REQUEST_GET_SCHEDULE';
export const REQUEST_ADD_SCHEDULE = 'REQUEST_ADD_SCHEDULE';
export const REQUEST_DELETE_SCHEDULE = 'REQUEST_DELETE_SCHEDULE';
export const SCHOOL_FORM = 'SCHOOL_FORM';
export const REQUEST_SCHOOL_CREATE = 'REQUEST_SCHOOL_CREATE';
export const REQUEST_SCHOOL_EDIT = 'REQUEST_SCHOOL_EDIT';
export const REQUEST_SCHOOL_DELETE = 'REQUEST_SCHOOL_DELETE';
export const REQUEST_SCHOOLS = 'REQUEST_SCHOOLS';
export const REQUEST_ALL_SCHOOLS = 'REQUEST_ALL_SCHOOLS';
export const SET_SCHOOLS = 'SET_SCHOOLS';
export const TEACHER_FORM = 'TEACHER_FORM';
export const REQUEST_TEACHER_CREATE = 'REQUEST_TEACHER_CREATE';
export const REQUEST_TEACHER_EDIT = 'REQUEST_TEACHER_EDIT';
export const REQUEST_TEACHER_DELETE = 'REQUEST_TEACHER_DELETE';
export const REQUEST_TEACHERS = 'REQUEST_TEACHERS';
export const REQUEST_TEACHER_PAID = 'REQUEST_TEACHER_PAID';
export const SET_TEACHERS = 'SET_TEACHERS';
export const GET_REPORTS = 'GET_REPORTS';
export const SET_REPORTS = 'SET_REPORTS';
export const SET_THEME_DATA = 'SET_THEME_DATA';
export const REQUEST_CHANGE_THEME = 'REQUEST_CHANGE_THEME';
export const SET_MODAL_DISPLAY = 'SET_MODAL_DISPLAY';
export const REQUEST_RATING = 'USER/REQUEST_RATING';
export const SET_RATING = 'USER/SET_RATING';
export const REQUEST_SAVE_GAMIFICATION = 'REQUEST_SAVE_GAMIFICATION';
export const UPDATE_PROPERTY_GAMIFICATION = 'UPDATE_PROPERTY_GAMIFICATION';
export const UPDATE_USER_FEATHERS = 'UPDATE_USER_FEATHERS';
export const REQUEST_SAVE_PURCHASE = 'REQUEST_SAVE_PURCHASE';
export const REQUEST_LOAD_TRANSACTIONS = 'REQUEST_LOAD_TRANSACTIONS';
export const REQUEST_LOAD_USER_TRANSACTIONS = 'REQUEST_LOAD_USER_TRANSACTIONS';
export const REQUEST_EDIT_TRANSACTION = 'REQUEST_EDIT_TRANSACTION';
export const REQUEST_INVITE_STUDENTS = 'REQUEST_INVITE_STUDENTS';
export const REQUEST_SEND_DATA_TO_EMAIL = 'REQUEST_SEND_DATA_TO_EMAIL';
export const REQUEST_CONVERT_UCOINS = 'REQUEST_CONVERT_UCOINS';
export const REQUEST_REFERRALS = 'REQUEST_REFERRALS';
export const REQUEST_FREE_STUDENTS = 'REQUEST_FREE_STUDENTS';
export const REQUEST_INVITE_CONFIRM = 'REQUEST_INVITE_CONFIRM';
export const REQUEST_INVITE_REJECT = 'REQUEST_INVITE_REJECT';
export const REQUEST_GET_PAYMENT = 'REQUEST_GET_PAYMENT';
export const REQUEST_MARK_TEST_READ = 'REQUEST_MARK_TEST_READ';
export const REQUEST_USER_INFO = 'REQUEST_USER_INFO';
export const REQUEST_PRODUCTS = 'REQUEST_PRODUCTS';
export const REQUEST_SAVE_PRODUCTS = 'REQUEST_SAVE_PRODUCTS';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const REQUEST_DELETED_USERS = 'REQUEST_DELETED_USERS';
export const REQUEST_DELETE_USER = 'REQUEST_DELETE_USER';
export const REQUEST_ALIVE_USER = 'REQUEST_ALIVE_USER';
export const REQUEST_USERS_LIST = 'REQUEST_USERS_LIST';
export const REQUEST_LOAD_OLIMP_PURCHASES = 'REQUEST_LOAD_OLIMP_PURCHASES';
export const REQUEST_RESET_FEATHERS = 'REQUEST_RESET_FEATHERS';
export const REQUEST_RESET_OLIMP_COUNTERS = 'REQUEST_RESET_OLIMP_COUNTERS';
export const REQUEST_SMGL_USERS = 'REQUEST_SMGL_USERS';
export const REQUEST_DELETE_SMGL_USERS = 'REQUEST_DELETE_SMGL_USERS';

export const host = process.env.BACKEND_URL;

export const optionsActive = [
  {
    value: 0,
    label: <FormattedMessage id="NO" />,
  },
  {
    value: 1,
    label: <FormattedMessage id="YES" />,
  },
];

export const optionsSex = [
  {
    value: 'male',
    label: <FormattedMessage id="MALE" />,
  },
  {
    value: 'female',
    label: <FormattedMessage id="FEMALE" />,
  },
];

export const optionsRoles = [
  {
    value: 1,
    label: <FormattedMessage id="ROLE_STUDENT" defaultMessage="ROLE_STUDENT" />,
  },
  {
    value: 2,
    label: <FormattedMessage id="ROLE_TEACHER" defaultMessage="ROLE_TEACHER" />,
  },
  {
    value: 3,
    label: <FormattedMessage id="ROLE_SCHOOL" defaultMessage="ROLE_SCHOOL" />,
  },
];

export const optionsRoleSwitch = [
  {
    value: 2,
    label: <FormattedMessage id="ROLE_TEACHER" defaultMessage="ROLE_TEACHER" />,
  },
  {
    value: 3,
    label: <FormattedMessage id="ROLE_SCHOOL" defaultMessage="ROLE_SCHOOL" />,
  },
];

// Init state
const initialState = {
  token: cookie.load('Authorization') || '',
  balance: '0',
  init: false,
  lang,
  localeMessages: languages[lang],
  tasks: [],
  user: {},
  role: 0,
  paid: true,
  students: [],
  groups: [],
  schedule: [],
  photo: {},
  schools: [],
  teachers: [],
  reports: {},
  gamification: {},
  unsavedGamification: {},
  rating: {},
  rooms: [],
  theme: {
    modal_display: false,
    theme: 'default',
    bone: 'brown',
  },
};
// console.log(initialState);
export const ROLE = {
  GUEST: 0,
  LEARNER: 1,
  TEACHER: 2,
  SCHOOL: 3,
  ADMIN: 4,
};

export const ROLE_TITLE = {
  [ROLE.GUEST]: 'ROLE_GUEST',
  [ROLE.LEARNER]: 'ROLE_STUDENT',
  [ROLE.TEACHER]: 'ROLE_TEACHER',
  [ROLE.SCHOOL]: 'ROLE_SCHOOL',
  [ROLE.ADMIN]: 'ROLE_ADMIN',
};

export const toUserOptions = (user, intl) => ({
  value: user._id,
  label: `${user.name} ${user.surname} (${intl.formatMessage({
    id: ROLE_TITLE[user.role] || ' ',
  })}) - ${user.email}`,
  role: user.role,
});

// Reducer
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROFILE:
      return {
        ...state,
        ...action.payload,
      };
    case CLEAN_USER:
      return { ...initialState, token: '' };
    case SET_INIT:
    case SET_TASKS:
    case SET_TOKEN:
    case SET_TOKENS:
    case SET_PAY_ACC:
    case SET_AVTIVITY:
    case SET_KYC_TOKEN:
    case SET_APPLICANT_ID:
    case SET_TWOFA_CHECKED:
    case SET_TWOFA_SECRET_TOKEN:
    case SET_USER:
    case SET_STUDENTS:
    case SET_GROUPS:
    case SET_SCHEDULE:
    case SET_SCHOOLS:
    case SET_ROOMS:
    case SET_TEACHERS:
    case SET_REPORTS:
    case SET_PRODUCTS:
      return {
        ...state,
        [action.meta]: action.payload,
      };
    case SET_RATING:
      return {
        ...state,
        rating: { ...state.rating, ...action.payload },
      };
    case SET_THEME_DATA:
      return {
        ...state,
        [action.meta]: action.payload,
        user: {
          ...state.user,
          [action.meta]: action.payload,
        },
      };
    case UPDATE_PROPERTY_GAMIFICATION: {
      return {
        ...state,
        unsavedGamification: action.payload.unsavedGamification,
      };
    }
    case UPDATE_USER_FEATHERS: {
      return {
        ...state,
        unsavedGamification: {
          ...state.unsavedGamification,
          feathers: (state.unsavedGamification.feathers || 0) + action.payload,
        },
      };
    }
    case SET_LOCALE:
      // console.log('SET_LOCALE', action.payload);
      return {
        ...state,
        lang: action.payload.lang,
      };
    case SET_LOCALE_MESSAGES:
      // console.log('SET_LOCALE_MESSAGES', action.payload);
      return {
        ...state,
        localeMessages: action.payload,
      };

    default:
      return state;
  }
};

export const updateGamification = unsavedGamification => dispatch =>
  dispatch({
    type: UPDATE_PROPERTY_GAMIFICATION,
    payload: { unsavedGamification },
  });

export const updateUserFeathers = feathers => dispatch =>
  dispatch({
    type: UPDATE_USER_FEATHERS,
    payload: feathers,
  });

export const changeProducts = products => dispatch =>
  dispatch({
    type: SET_PRODUCTS,
    payload: products,
    meta: 'products',
  });

export const fetchConvertUcoins = () => ({
  [RSAA]: {
    endpoint: `${host}/users/convert`,
    method: 'POST',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_CONVERT_UCOINS,
      },
    })),
  },
});

export const fetchReferrals = () => ({
  [RSAA]: {
    endpoint: `${host}/users/referrals`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_REFERRALS,
      },
    })),
  },
});

export const fetchGetPayment = (ptype = 'default', formData) => ({
  [RSAA]: {
    endpoint: `${host}/users/payment/${ptype}`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_PAYMENT,
      },
    })),
  },
});

// Actions
export const fetchReports = studentId => ({
  [RSAA]: {
    endpoint: `${host}/tasks/?student=${studentId}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: GET_REPORTS,
      },
    })),
  },
});

export const fetchSaveGamification = formData => ({
  [RSAA]: {
    endpoint: `${host}/users/gamification`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_SAVE_GAMIFICATION,
      },
    })),
  },
});

export const fetchLoadTransactions = formData => ({
  [RSAA]: {
    endpoint: `${host}/transactions/`,
    method: 'GET',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_LOAD_TRANSACTIONS,
      },
    })),
  },
});

export const fetchCheckTransaction = id => ({
  [RSAA]: {
    endpoint: `${host}/transactions/${id}`,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_LOAD_TRANSACTIONS,
      },
    })),
  },
});

export const fetchEditTransaction = (id, formData) => ({
  [RSAA]: {
    endpoint: `${host}/transactions/${id}`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_EDIT_TRANSACTION,
      },
    })),
  },
});

export const fetchLoadUserTransactions = userId => ({
  [RSAA]: {
    endpoint: `${host}/transactions/list/${userId ? `?userId=${userId}` : ''}`,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_LOAD_USER_TRANSACTIONS,
      },
    })),
  },
});

export const fetchLoadOlimpPurchases = (userId, olimpType) => ({
  [RSAA]: {
    endpoint: `${host}/transactions/olimppurchases?${
      userId ? `userId=${userId}&` : ''
    }olimpType=${olimpType}`,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_LOAD_OLIMP_PURCHASES,
      },
    })),
  },
});

export const fetchResetOlimpCounters = olimpType => ({
  [RSAA]: {
    endpoint: `${host}/users/reset-olimp`,
    method: 'POST',
    body: JSON.stringify({ olimpType }),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_RESET_OLIMP_COUNTERS,
      },
    })),
  },
});

export const fetchLoadData = () => ({
  [RSAA]: {
    endpoint: `${host}/users/me`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_LOAD_DATA,
      },
    })),
  },
});

export const fetchUsersList = () => ({
  [RSAA]: {
    endpoint: `${host}/users/list`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_USERS_LIST,
      },
    })),
  },
});

export const fetchDeletedUsers = () => ({
  [RSAA]: {
    endpoint: `${host}/users/deleted`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_DELETED_USERS,
      },
    })),
  },
});

export const fetchUserDelete = id => ({
  [RSAA]: {
    endpoint: `${host}/users/deleted/${id}`,
    method: 'DELETE',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_DELETE_USER,
      },
    })),
  },
});

export const fetchUserAlive = id => ({
  [RSAA]: {
    endpoint: `${host}/users/alive/${id}`,
    method: 'POST',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_ALIVE_USER,
      },
    })),
  },
});

export const fetchUserInfo = id => ({
  [RSAA]: {
    endpoint: `${host}/users/${id}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_USER_INFO,
      },
    })),
  },
});

export const fetchMarkTestRead = () => ({
  [RSAA]: {
    endpoint: `${host}/users/test`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_MARK_TEST_READ,
      },
    })),
  },
});

export const fetchEdit = formData => ({
  [RSAA]: {
    endpoint: `${host}/users/edit`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_EDIT_DATA,
      },
    })),
  },
});

export const fetchLoadPhoto = (id, photo) => ({
  [RSAA]: {
    endpoint: `${host}/files/photo/${id}`,
    method: 'POST',
    body: photo, // фото грузится через формдату, без преобразований в base и json. const photo = new FormData(); photo.append('photo', /*photo*/);
    // headers: { 'Content-Type': 'multipart/form-data' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_EDIT_DATA,
      },
    })),
  },
});

export const fetchChangePassword = formData => ({
  [RSAA]: {
    endpoint: `${host}/users/password/`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_CHANGE_PASSWORD,
      },
    })),
  },
});

export const fetchVerifyPassword = formData => ({
  [RSAA]: {
    endpoint: `${host}/users/verify/`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_VERIFY_PASSWORD,
      },
    })),
  },
});

export const fetchSavePurchase = formData => ({
  [RSAA]: {
    endpoint: `${host}/users/purchase/`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_SAVE_PURCHASE,
      },
    })),
  },
});

export const fetchChangeTheme = formData => ({
  [RSAA]: {
    endpoint: `${host}/users/theme`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_CHANGE_THEME,
      },
    })),
  },
});

export const fetchStudentCreate = formData => ({
  [RSAA]: {
    endpoint: `${host}/students/`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_STUDENT_CREATE,
      },
    })),
  },
});

export const fetchStudentEdit = (id, formData) => ({
  [RSAA]: {
    endpoint: `${host}/students/${id}`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_STUDENT_EDIT,
      },
    })),
  },
});

export const fetchStudentDelete = id => ({
  [RSAA]: {
    endpoint: `${host}/students/${id}`,
    method: 'DELETE',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_STUDENT_DELETE,
      },
    })),
  },
});

export const fetchStudents = () => ({
  [RSAA]: {
    endpoint: `${host}/students/`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_STUDENTS,
      },
    })),
  },
});

export const fetchStudent = id => ({
  [RSAA]: {
    endpoint: `${host}/students/${id}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_STUDENT,
      },
    })),
  },
});

export const fetchOwnStudents = () => ({
  [RSAA]: {
    endpoint: `${host}/students/own`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_STUDENTS,
      },
    })),
  },
});

export const fetchFreeStudents = () => ({
  [RSAA]: {
    endpoint: `${host}/students/free`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_FREE_STUDENTS,
      },
    })),
  },
});

export const fetchInviteStudents = formData => ({
  [RSAA]: {
    endpoint: `${host}/users/invite`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_INVITE_STUDENTS,
      },
    })),
  },
});

export const fetchConfirmInvitation = formData => ({
  [RSAA]: {
    endpoint: `${host}/users/invite/confirm`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_INVITE_CONFIRM,
      },
    })),
  },
});

export const fetchRejectInvitation = formData => ({
  [RSAA]: {
    endpoint: `${host}/users/invite/reject`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_INVITE_REJECT,
      },
    })),
  },
});

export const fetchGroupCreate = formData => ({
  [RSAA]: {
    endpoint: `${host}/groups/`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GROUP_CREATE,
      },
    })),
  },
});

export const fetchGroupEdit = (id, formData) => ({
  [RSAA]: {
    endpoint: `${host}/groups/${id}`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GROUP_EDIT,
      },
    })),
  },
});

export const fetchGroupDelete = id => ({
  [RSAA]: {
    endpoint: `${host}/groups/${id}`,
    method: 'DELETE',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GROUP_DELETE,
      },
    })),
  },
});

export const fetchGroups = () => ({
  [RSAA]: {
    endpoint: `${host}/groups/`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GROUPS,
      },
    })),
  },
});

export const fetchOwnGroups = () => ({
  [RSAA]: {
    endpoint: `${host}/groups/own`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GROUPS,
      },
    })),
  },
});

export const fetchSchedule = filter => ({
  [RSAA]: {
    endpoint: `${host}/schedule`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(filter),
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_SCHEDULE,
      },
    })),
  },
});

export const fetchAddSchedule = formData => ({
  [RSAA]: {
    endpoint: `${host}/schedule`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_ADD_SCHEDULE,
      },
    })),
  },
});

export const fetchDeleteSchedule = formData => ({
  [RSAA]: {
    endpoint: `${host}/schedule`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_DELETE_SCHEDULE,
      },
    })),
  },
});

export const fetchSchoolCreate = formData => ({
  [RSAA]: {
    endpoint: `${host}/schools/`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_SCHOOL_CREATE,
      },
    })),
  },
});

export const fetchSchoolEdit = (id, formData) => ({
  [RSAA]: {
    endpoint: `${host}/schools/${id}`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_SCHOOL_EDIT,
      },
    })),
  },
});

export const fetchSchoolDelete = id => ({
  [RSAA]: {
    endpoint: `${host}/schools/${id}`,
    method: 'DELETE',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_SCHOOL_DELETE,
      },
    })),
  },
});

export const fetchSchools = () => ({
  [RSAA]: {
    endpoint: `${host}/schools/`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_SCHOOLS,
      },
    })),
  },
});

export const fetchAllSchools = () => ({
  [RSAA]: {
    endpoint: `${host}/schools/all`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_ALL_SCHOOLS,
      },
    })),
  },
});

export const fetchTeacherCreate = formData => ({
  [RSAA]: {
    endpoint: `${host}/teachers/`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_TEACHER_CREATE,
      },
    })),
  },
});

export const fetchTeacherEdit = (id, formData) => ({
  [RSAA]: {
    endpoint: `${host}/teachers/${id}`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_TEACHER_EDIT,
      },
    })),
  },
});

export const fetchTeacherDelete = id => ({
  [RSAA]: {
    endpoint: `${host}/teachers/${id}`,
    method: 'DELETE',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_TEACHER_DELETE,
      },
    })),
  },
});

export const fetchTeachers = () => ({
  [RSAA]: {
    endpoint: `${host}/teachers/`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_TEACHERS,
      },
    })),
  },
});

export const fetchTeacherPaid = () => ({
  [RSAA]: {
    endpoint: `${host}/teachers/paid`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_TEACHER_PAID,
      },
    })),
  },
});

export const fetchConfirmCode = formData => ({
  [RSAA]: {
    endpoint: `${host}/users/sms/${formData.token}/?token=${formData.token}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_CONFIRM_CODE,
      },
    })),
  },
});

export const fetchConfirmPhone = formData => ({
  [RSAA]: {
    endpoint: `${host}/users/phone/`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_CONFIRM_PHONE,
      },
    })),
  },
});

export const fetchTokens = () => ({
  [RSAA]: {
    endpoint: `${host}/users/tokens`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_TOKENS,
      },
    })),
  },
});

export const fetchKycAccessData = userId => ({
  [RSAA]: {
    endpoint: `${host}/users/kyc/accessData/?userId=${userId}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_KYC_ACCESS_DATA,
      },
    })),
  },
});

export const fetchTwofaSecretToken = () => ({
  [RSAA]: {
    endpoint: `${host}/users/2fa/activate/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_TWOFA_SECRET_TOKEN,
      },
    })),
  },
});

export const fetchTwofaActivate = formData => ({
  [RSAA]: {
    endpoint: `${host}/users/2fa/activate/confirm/`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_TWOFA_ACTIVATE,
      },
    })),
  },
});

export const fetchTwofaDeactivate = formData => ({
  [RSAA]: {
    endpoint: `${host}/users/2fa/deactivate/`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_TWOFA_DEACTIVATE,
      },
    })),
  },
});

export const fetchCreateApplicant = data => ({
  [RSAA]: {
    endpoint: `${host}/users/kyc/applicant`,
    method: 'POST',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_CREATE_APPLICANT,
      },
    })),
  },
});

export const fetchTwofaCheck = formData => ({
  [RSAA]: {
    endpoint: `${host}/login/2fa/`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_TWOFA_CHECK,
      },
    })),
  },
});

export const fetchRequestPayment = formData => ({
  [RSAA]: {
    endpoint: `${host}/users/payment/`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_PAYMENT,
      },
    })),
  },
});

export const cleanUser = () => ({
  type: CLEAN_USER,
});

export const fetchLoadReferrals = () => ({
  [RSAA]: {
    endpoint: `${host}/users/referrals`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_LOAD_REFERRALS,
      },
    })),
  },
});

export const fetchLoadTasks = () => ({
  [RSAA]: {
    endpoint: `${host}/tasks`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_LOAD_TASKS,
      },
    })),
  },
});

export const fetchRequestSendData = formData => ({
  [RSAA]: {
    endpoint: `${host}/users/send`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_SEND_DATA_TO_EMAIL,
      },
    })),
  },
});

export const fetchRequestRooms = () => ({
  [RSAA]: {
    endpoint: `${host}/users/rooms`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_ROOMS,
      },
    })),
  },
});

export const fetchLoadRating = filter => ({
  [RSAA]: {
    endpoint: `${host}/users/rating/${filter}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_RATING,
      },
    })),
  },
});

export const fetchResetFeathers = () => ({
  [RSAA]: {
    endpoint: `${host}/users/reset-feathers`,
    method: 'POST',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_RESET_FEATHERS,
      },
    })),
  },
});

export const fetchProducts = () => ({
  [RSAA]: {
    endpoint: `${host}/products/`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_PRODUCTS,
      },
    })),
  },
});

export const fetchSaveProducts = products => ({
  [RSAA]: {
    endpoint: `${host}/products/`,
    method: 'POST',
    body: JSON.stringify(products),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_SAVE_PRODUCTS,
      },
    })),
  },
});

export const fetchSmglUsers = () => ({
  [RSAA]: {
    endpoint: `${host}/users/smgl`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_SMGL_USERS,
      },
    })),
  },
});

export const fetchDeleteSmglUsers = ids => ({
  [RSAA]: {
    endpoint: `${host}/users/smgl`,
    method: 'DELETE',
    body: JSON.stringify({ ids }),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_DELETE_SMGL_USERS,
      },
    })),
  },
});

export default userReducer;
